<template>
  <div class="flex bg-gray-100">
    <div
      class="px-16 py-8 max-w-md mx-auto sm:max-w-xl lg:max-w-full lg:w-1/2 lg:py-24 lg:px-12"
    >
      <div class="xl:max-w-lg xl:ml-auto">
        <!-- <img
          src="../assets/images/LogoHof.png"
          alt="direkt vom Hof"
          class="h-16 w-auto "
        /> -->

        <!-- foto small version -->
        <img
          src="../assets/images/HofLook.jpg"
          alt="Hof Look"
          class="mt-6 rounded-lg shadow-xl sm:mt-8 sm:h-64 sm:w-full sm:object-cover sm:object-center lg:hidden "
          fit="cover"
        />
        <h1
          class="mt-6 text-2xl font-bold text-green-800 leading-tight sm:text-4xl sm:mt-8 lg:text-3xl xl:text-4xl:"
        >
          Produkte vom Hof <br />
          <span class="text-orange-500"> Aus Deiner Gegend</span>
        </h1>
        <p class="mt-2 sm:mt-4 text-green-800 sm:text-xl">
          Hier gibt es natürliche Lebensmittel aus Deiner Gegend. Bestelle
          klimafreundlich. Wir fahren einmal am Tag alle Höfe an und liefern
          direkt zu Dir nach Hause.
        </p>
        <div class="mt-4 sm:mt-6">
          <router-link
            to="/categorie"
            class="inline-block bg-green-800 hover:bg-green-500 focus:outline-none focus:shadow-outline text-white sm:text-base px-5 py-3 rounded-lg shadow-lg uppercase tracking-wider font-semibold text-sm"
            >Los geht's</router-link
          >
        </div>
      </div>
    </div>
    <!-- foto for large version -->
    <div class="hidden lg:block lg:w-1/2 lg:relative">
      <img
        src="../assets/images/HofLook.jpg"
        alt="Hof Look"
        class="absolut inset-0 h-full w-full object-cover object-center"
        fit="cover"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  metaInfo: {
    title: "Vom Hof",
  },
};
</script>
